export { default } from './FeaturedHotel';
